/**
 * Clickable blocks - entire block will be clickable
 * Styles are in _helpers.scss under .block--linked
 *
 * Usage:
 * {{#link}} data-clickable="{{link_path}}"{{/link}}
 * {{#url}} data-clickable="{{href}}"{{/url}}
 */

(function($) {
  Drupal.behaviors.clickable = {
    attach: function(context) {
      $('[data-clickable!=""][data-clickable]', context).once('clickable').addClass('block--linked').on('click', function() {
        if (window.location.hash) {
          history.replaceState('', '', $(this).data('clickable')); // fix for hitchhiking hashes
        }
        window.location.href = $(this).data('clickable');
      });
    }
  };
})(jQuery);

!function(a){Drupal.behaviors.clickable={attach:function(c){a('[data-clickable!=""][data-clickable]',c).once("clickable").addClass("block--linked").on("click",(function(){window.location.hash&&history.replaceState("","",a(this).data("clickable")),window.location.href=a(this).data("clickable")}))}}}(jQuery);
//# sourceMappingURL=clickable_block.min.js.map

(function($, generic) {
  // Route the old perlgem overlay method to colorbox:
  generic.overlay = {
    launch: function(args, event) {
      if (typeof event !== 'undefined') {
        event.preventDefault();
      }
      // ColorBox args sent along
      var cboxArgs = {
        'height': '600px',
        'width': '768px',
        'margin': 'auto'
      };
      // Smoosh in any overrides from other calls, looks like args.cssStyle
      _.extend(cboxArgs, args);
      _.extend(cboxArgs, args.cssStyle); // get height/width overrides
      // When mobile, override any height/width and set to 100%
      // Also set fixed to true, to avoid scrolling the whole overlay
      if ($(window).width() <= 768) {
        _.extend(cboxArgs, {height: '100%', width: '100%', fixed: 'true'});
      }
      // Actual content of the overlay
      if (typeof args.content !== 'undefined') {
        cboxArgs.html = args.content;
      }
      // A custome class each launcher has the option of setting
      if (typeof args.cssClass !== 'undefined') {
        cboxArgs.className = args.cssClass;
      }
      // Scroll to an anchor, if sent over
      if (typeof args.inPageAnchor !== 'undefined') {
        cboxArgs.onComplete = function() {
          $('#cboxLoadedContent').scrollTo($('#' + args.inPageAnchor), 50);
        };
      }
      // Launch it
      $.colorbox(cboxArgs);
    },

    initLinks: function() {
      // Give us access to the parent scope so we can hit .launch()
      var self = this;
      // Links are tiggered via class, but indicate if already processed
      var $triggers = $('.overlay-link:not(.overlay-ready)').addClass('overlay-ready');

      // Depending on the type of link, the overlay needs to do something unique
      $triggers.each(function() {
        var args = {
              cssStyle: {}
            }, // args sent to overlay
            linkClassNames = $(this).attr('class'), // class name sent to colorbox
            linkHref = $(this).attr('href'), // actual href
            linkHrefWithEmbed = linkHref,
            inPageAnchor = $(this).data('inpage-anchor'), // see try/catch below
            overlayElement = $(this).data('overlay-content'); // use an existing element as content

        // used in overlay linking below
        var urlParts = document.createElement('a'); //
        urlParts.href = linkHref; //

        // Parse height options out of the link's class
        var widthRegexResults = linkClassNames.match(/overlay-width-(\d+)/);
        if (widthRegexResults) {
          args.cssStyle.width = widthRegexResults[1];
        }
        // Parse width options
        var heightRegexResults = linkClassNames.match(/overlay-height-(\d+)/);
        if (heightRegexResults) {
          args.cssStyle.height = heightRegexResults[1];
        }
        // Add a custom class, optionally
        var cssClassRegexResults = linkClassNames.match(/overlay-addclass-([a-z\-\_]+)/);
        if (cssClassRegexResults) {
          args.className = cssClassRegexResults[1];
        }

        // Make sure embed doesn't already exist. This gets added form internal
        // drupal embeddable urls
        if (typeof overlayElement !== 'undefined') {
          args.content = $(overlayElement).html();
        } else {
          try {
            if (!linkHref.match(/[\&\?]embed=1($|&)/)) {
              linkHrefWithEmbed = (urlParts.pathname.charAt(0) == '/' ? urlParts.pathname : '/' + urlParts.pathname) + (urlParts.search === '' ? '?' : urlParts.search + '&') + 'embed=1' + urlParts.hash;

              // Retain original link if it included the protocol.
              if (linkHref.match(/https?:\/\//)) {
                linkHrefWithEmbed = urlParts.protocol + '//' + urlParts.host + linkHrefWithEmbed;
              }
            }
          } catch (e) {
            linkHrefWithEmbed = linkHref;
          }

          // Fix the link within the page
          $(this).attr('href', linkHrefWithEmbed);
          // But this is actually used to launch overlay
          args.href = linkHrefWithEmbed;
        }

        // scrollTo behavior if we have a data attribute
        if (typeof inPageAnchor !== 'undefined') {
          args.inPageAnchor = inPageAnchor;
        }

        // Launch a colorbox overlay
        $(this).on('click', function(e) {
          // use our canonical launch function for all the goodies
          self.launch(args, e);
        });
      }); // .each()
    }, // initLinks

    hide: function() {
      $.colorbox.close();
    },

    getRBKeys: function() {
      generic.rb.language = generic.rb('language');
      generic.rb.language.rb_close = generic.rb.language.get('close');
    }
  };

  $(function() {
    generic.overlay.getRBKeys();
    generic.overlay.initLinks();
  });
})(jQuery, window.generic || {});

!function(e,t){t.overlay={launch:function(t,a){void 0!==a&&a.preventDefault();var n={height:"600px",width:"768px",margin:"auto"};_.extend(n,t),_.extend(n,t.cssStyle),e(window).width()<=768&&_.extend(n,{height:"100%",width:"100%",fixed:"true"}),void 0!==t.content&&(n.html=t.content),void 0!==t.cssClass&&(n.className=t.cssClass),void 0!==t.inPageAnchor&&(n.onComplete=function(){e("#cboxLoadedContent").scrollTo(e("#"+t.inPageAnchor),50)}),e.colorbox(n)},initLinks:function(){var t=this;e(".overlay-link:not(.overlay-ready)").addClass("overlay-ready").each((function(){var a={cssStyle:{}},n=e(this).attr("class"),o=e(this).attr("href"),c=o,h=e(this).data("inpage-anchor"),i=e(this).data("overlay-content"),r=document.createElement("a");r.href=o;var s=n.match(/overlay-width-(\d+)/);s&&(a.cssStyle.width=s[1]);var l=n.match(/overlay-height-(\d+)/);l&&(a.cssStyle.height=l[1]);var d=n.match(/overlay-addclass-([a-z\-\_]+)/);if(d&&(a.className=d[1]),void 0!==i)a.content=e(i).html();else{try{o.match(/[\&\?]embed=1($|&)/)||(c=("/"==r.pathname.charAt(0)?r.pathname:"/"+r.pathname)+(""===r.search?"?":r.search+"&")+"embed=1"+r.hash,o.match(/https?:\/\//)&&(c=r.protocol+"//"+r.host+c))}catch(e){c=o}e(this).attr("href",c),a.href=c}void 0!==h&&(a.inPageAnchor=h),e(this).on("click",(function(e){t.launch(a,e)}))}))},hide:function(){e.colorbox.close()},getRBKeys:function(){t.rb.language=t.rb("language"),t.rb.language.rb_close=t.rb.language.get("close")}},e((function(){t.overlay.getRBKeys(),t.overlay.initLinks()}))}(jQuery,window.generic||{});
//# sourceMappingURL=overlay.min.js.map

(function($, site) {
  site.template = site.template || {};
  site.templates = site.templates || {};

  site.template.get = function(args) {
    var template = site.templates[args.name];
    if (_.isUndefined(template)) {
      console.log('The template ' + args.name + ' cannot be found');
    }
    var data = {
      globals: {
        t: site.translations,
        variables: {
        // IE doesn't support location.origin, so...
          site_url: window.location.protocol + '//' + window.location.hostname
        }
      }
    };
    // include config settings from product module
    if (!_.isUndefined(Drupal) && !_.isUndefined(Drupal.settings) && !_.isUndefined(Drupal.settings.product)) {
      $.extend(data.globals.variables, Drupal.settings.product);
    }
    var view = $.extend({}, args.data, data, template.data);
    var partials = {};

    if (!_.isUndefined(template.partials)) {
      $.each(template.partials, function(key, name) {
        if (_.isUndefined(site.templates[name])) {
          throw new Error('The partial ' + name + ' cannot be found');
        }

        partials[key] = site.templates[name].content;
      });
    }

    var rendered = Mustache.render(template.content, view, partials);

    if (_.isFunction(args.callback)) {
      var so = args.callback(rendered);
      if (!_.isUndefined(so)) {
        return so;
      }
    }

    return rendered;
  };
})(jQuery, window.site || {});

!function(e,t){t.template=t.template||{},t.templates=t.templates||{},t.template.get=function(n){var a=t.templates[n.name];_.isUndefined(a)&&console.log("The template "+n.name+" cannot be found");var i={globals:{t:t.translations,variables:{site_url:window.location.protocol+"//"+window.location.hostname}}};_.isUndefined(Drupal)||_.isUndefined(Drupal.settings)||_.isUndefined(Drupal.settings.product)||e.extend(i.globals.variables,Drupal.settings.product);var l=e.extend({},n.data,i,a.data),s={};_.isUndefined(a.partials)||e.each(a.partials,(function(e,n){if(_.isUndefined(t.templates[n]))throw new Error("The partial "+n+" cannot be found");s[e]=t.templates[n].content}));var o=Mustache.render(a.content,l,s);if(_.isFunction(n.callback)){var r=n.callback(o);if(!_.isUndefined(r))return r}return o}}(jQuery,window.site||{});
//# sourceMappingURL=template.min.js.map
